import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import urls, { codeUrl } from '@/constants/urls';
import AdminCollectionMenu from '@/components/ribbon-actions/AdminCollectionMenu';
import AdminUserMenu from '@/components/ribbon-actions/AdminUserMenu';
import AdminThemeMenu from '@/components/ribbon-actions/AdminThemeMenu';
import AdminRoleMenu from '../ribbon/AdminRoleMenu';
import RibbonMenu from '../ribbon/RibbonMenu';
import Selectors from '../hooks/selectors';

const AdminLauncherMenu = () => {
  const state = Selectors.useAdminLauncherMenu();
  const collectionArray = [state.allowCollections, state.allowNewCollections].some(Boolean);
  const roleArray = [state.allowRoles, state.allowNewRoles].some(Boolean);
  const userGroupTokenArray = [state.allowUsers,
    state.allowNewUserGroup,
    state.allowUserGroups,
    state.allowTokens].some(Boolean);
  const themeVocabArray = [state.allowThemes, state.allowVocabularies].some(Boolean);

  return (
    <Dropdown
      className="aridhia-admin-launcher-menu"
      icon={null}
      trigger={<RibbonMenu name="admin" message="fair.launcher.admin" icon="settings" />}
    >
      <Dropdown.Menu>
        <AdminCollectionMenu
          url={codeUrl(urls.COLLECTION, state.newCollectionCode, '#')}
          allowNewCollections={state.allowNewCollections}
          allowCollections={state.allowCollections}
        />
        {collectionArray && (roleArray || userGroupTokenArray || themeVocabArray) && <Dropdown.Divider />}
        <AdminRoleMenu allowNewRoles={state.allowNewRoles} allowRoles={state.allowRoles} />
        {roleArray && (userGroupTokenArray || themeVocabArray) && <Dropdown.Divider />}
        <AdminUserMenu
          allowUsers={state.allowUsers}
          allowUserGroups={state.allowUserGroups}
          allowTokens={state.allowTokens}
          allowNewUserGroup={state.allowNewUserGroup}
          url={codeUrl(urls.USER_GROUP, state.newUserGroupCode, '#')}
        />
        {userGroupTokenArray && themeVocabArray && <Dropdown.Divider />}
        <AdminThemeMenu allowThemes={state.allowThemes} allowVocabularies={state.allowVocabularies} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AdminLauncherMenu;
